import { createFileRoute } from '@tanstack/react-router';
import { object, optional, parse, picklist } from 'valibot';

import { ensureRouteAccess } from '@/lib/auth/guards';

export const PATIENTS_TABS = ['my-panel', 'all', 'medrec'] as const;
export type PatientsTab = (typeof PATIENTS_TABS)[number];

export const Route = createFileRoute('/(authenticated)/patients/')({
  validateSearch: (search) =>
    parse(
      object({
        tab: optional(picklist(PATIENTS_TABS)),
      }),
      search,
    ),
  beforeLoad: ensureRouteAccess('/patients'),
  head: () => ({
    meta: [
      {
        title: 'Alopex Health | Patients',
      },
    ],
  }),
});
